// Pains section (US-108) — section header with AI assist + the sentence-list
// sub-editor. JSX lifted verbatim from BusinessEditor.

import { useT } from '@barel/i18n';
import { BAiButton, Card } from '@barel/ui';

import { SentenceListEditor } from '../ValuePropEditor';
import type { BusinessDraft } from '../lib/defaults';
import { SectionHeader } from './SectionHeader';
import type { RunAi, SetField } from './types';

export interface PainsSectionProps {
  pains: BusinessDraft['pains'];
  onChange: SetField;
  runAi: RunAi;
  aiBusyField: string | null;
}

export function PainsSection({ pains, onChange, runAi, aiBusyField }: PainsSectionProps) {
  const t = useT('businesses');

  return (
    <Card padding="lg" radius="2xl" data-testid="business-section-pains">
      <SectionHeader
        title={t('sections.pains')}
        subtitle={t('pains.subtitle')}
        action={
          <BAiButton
            onClick={() => void runAi('pains')}
            busy={aiBusyField === 'pains'}
            label={t('pains.ai')}
            busyLabel={t('pains.aiBusy')}
            data-testid="business-pains-ai"
          />
        }
      />
      <SentenceListEditor
        values={pains}
        onChange={(next) => onChange('pains', next)}
        placeholder={t('pains.placeholder')}
        addLabel={t('pains.add')}
        testId="business-pains"
      />
    </Card>
  );
}
